import type { ProjectVerdict } from '../types/project';

/** Headline word per verdict, shown in the verdict pill. */
export const VERDICT_LABEL: Record<ProjectVerdict, string> = {
  'on-track': 'On track',
  'at-risk': 'At risk',
  'off-track': 'Will miss deadline',
};

/** Verdict pill chrome - the loudest read on the page. */
export const VERDICT_PILL: Record<ProjectVerdict, string> = {
  'on-track':
    'bg-emerald-50 text-emerald-700 ring-1 ring-inset ring-emerald-200',
  'at-risk':
    'bg-rose-600 text-white shadow-[0_8px_22px_-6px_rgba(244,63,94,0.6)]',
  'off-track':
    'bg-rose-600 text-white shadow-[0_8px_22px_-6px_rgba(244,63,94,0.6)]',
};

/** Saturated left rail that brands the verdict panel by standing. */
export const VERDICT_RAIL: Record<ProjectVerdict, string> = {
  'on-track': 'bg-emerald-500',
  'at-risk': 'bg-rose-500',
  'off-track': 'bg-rose-600',
};

/** Color for the projected date + slip - rose when the date is in danger. */
export const VERDICT_ACCENT_TEXT: Record<ProjectVerdict, string> = {
  'on-track': 'text-emerald-600',
  'at-risk': 'text-rose-600',
  'off-track': 'text-rose-600',
};
